(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lf-cart-drawer"]) return;
  try {
    
  var drawer = document.querySelector('[data-lf-drawer]');
  if (drawer) {
    var itemsEl = drawer.querySelector('[data-lf-cart-items]');
    var subEl = drawer.querySelector('[data-lf-cart-subtotal]');

    function fail() {
      itemsEl.innerHTML = '<p class="lf-drawer__empty" role="alert">Something flickered — <button type="button" class="lf-drawer__retry" data-lf-cart-retry>try again</button></p>';
    }
    function render(cart) {
      document.querySelectorAll('[data-lf-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      subEl.textContent = LF.money(cart.total_price);
      if (!cart.items.length) { itemsEl.innerHTML = '<p class="lf-drawer__empty">The rack is empty.</p>'; return; }
      itemsEl.innerHTML = cart.items.map(function (it) {
        return '<div class="lf-drawer__item">' +
          '<img src="' + (it.image ? LF.esc(it.image) + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '') + '" width="60" height="60" alt="">' +
          '<div><p>' + LF.esc(it.product_title) + '</p><p class="muted">' + LF.esc(it.variant_title || '') + '</p>' +
          '<span class="lf-drawer__qty">' +
          '<button type="button" data-lf-line="' + LF.esc(it.key) + '" data-lf-set="' + (it.quantity - 1) + '">−</button>' +
          '<span>' + it.quantity + '</span>' +
          '<button type="button" data-lf-line="' + LF.esc(it.key) + '" data-lf-set="' + (it.quantity + 1) + '">+</button>' +
          '</span></div>' +
          '<p>' + LF.money(it.final_line_price) + '</p></div>';
      }).join('');
    }
    function refresh() {
      return fetch('/cart.js').then(function (r) {
        if (!r.ok) throw new Error('cart fetch failed');
        return r.json();
      }).then(render).catch(fail);
    }
    function open() { drawer.removeAttribute('hidden'); requestAnimationFrame(function () { drawer.classList.add('is-open'); }); refresh(); }
    function close() { drawer.classList.remove('is-open'); setTimeout(function () { drawer.setAttribute('hidden', ''); }, 460); }

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-lf-cart-open]');
      var closeBtn = e.target.closest('[data-lf-cart-close]');
      var qtyBtn = e.target.closest('[data-lf-line]');
      var retryBtn = e.target.closest('[data-lf-cart-retry]');
      if (openBtn) { e.preventDefault(); open(); }
      if (closeBtn) { close(); }
      if (retryBtn) { refresh(); }
      if (qtyBtn) {
        // Line-item keys contain colons — pass whole, never split.
        fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: qtyBtn.getAttribute('data-lf-line'), quantity: Math.max(0, parseInt(qtyBtn.getAttribute('data-lf-set'), 10)) })
        }).then(function (r) {
          if (!r.ok) throw new Error('change failed');
          return r.json();
        }).then(render).catch(fail);
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hasAttribute('hidden')) close(); });
    document.addEventListener('lf:cart:added', open);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-teaser"] && !Shopify.designMode) return;
  try {
    
  // Flicker the whole wordmark lockup (sign + subtitle) on as one fixture, once per browser session; respect reduced motion.
  var sign = document.querySelector('.lf-teaser__wordmark');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (sign && !reduced && !sessionStorage.getItem('lfFlickered')) {
    sign.classList.add('lf-flicker-on');
    sessionStorage.setItem('lfFlickered', '1');
  }

  } catch(e) { console.error(e); }
})();
})();
